import InputNumericFormat from "./InputNumericFormat";

export default InputNumericFormat;
